import { definePreset } from "@primeng/themes";
import Aura from '@primeng/themes/aura';

const palettePilat = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#e6f0fb',
            100: '#cce1f7',
            200: '#99c3ee',
            300: '#66a5e5',
            400: '#3387dd',
            500: '#004585', // Custom primary color
            600: '#003c78',
            700: '#003266',
            800: '#002953',
            900: '#001f42',
            950: '#001231'
        },
        secondary: {
            50: '#fff4e6',
            100: '#ffeacc',
            200: '#ffd599',
            300: '#ffc066',
            400: '#ffab33',
            500: '#EE7F01', // Custom secondary color
            600: '#d77101',
            700: '#b86001',
            800: '#984f01',
            900: '#783e01',
            950: '#502900'
        },
        text: {
            default: '#373737', // Custom text color
            error: '#E42F17',   // Custom text error color
        }
    }
});

const paletteNuevaSantaCruz = definePreset(Aura, {
    semantic: {

        primary: {
            "50": "#e0f3f0",
            "100": "#b3e2d8",
            "200": "#83d0bf",
            "300": "#50bda5",
            "400": "#29ad92",
            "500": "#029e81",
            "600": "#009174",
            "700": "#008165",
            "800": "#007156",
            "900": "#00543b"
        },
        secondary: {
            "50": "#e2f5fc",
            "100": "#b5e5f7",
            "200": "#85d4f2",
            "300": "#5ac2ec",
            "400": "#3eb6e9",
            "500": "#2ba9e6",
            "600": "#259bd7",
            "700": "#1f88c4",
            "800": "#1c77b0",
            "900": "#14588e"
        },

        text: {
            default: '#373737', // Custom text color
            error: '#E42F17',   // Custom text error color
        }
    }
});

export const Palettes: { [key: number]: any } = {
    1200: palettePilat,
    1300: palettePilat,
    1600: palettePilat,
    1700: palettePilat,
    1800: paletteNuevaSantaCruz,
    2400: palettePilat,
};